module.exports = __webpack_public_path__ + "static/media/airbnb_register_photo.6e1a2faf.jpg";